import { UserRole } from '@hobt/constants';
import { Arrears } from './Arrears';

export const useFlyoutAccess = () => {
  const isReadOnly = (roles: UserRole[], arrears: Arrears) => {
    const isMasterUser = roles.includes(UserRole.MasterUser);
    const isClerkAndPeriodOpenAndLoanInformationAvailable =
      roles.includes(UserRole.Clerk) &&
      arrears.reportingPeriodStatus === 'open' &&
      !arrears.loanInformationMissing;

    return !(isMasterUser || isClerkAndPeriodOpenAndLoanInformationAvailable);
  };

  return {
    isReadOnly
  };
};
